import React, { Component, Fragment } from 'react';
import { compose } from '../../../reactApolloCompat';
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep';
import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Icon } from '@mui/material';
import Hidden from '../../Hidden';
import Typography from '@mui/material/Typography';
import { InlineField } from '../../layout/Inline';
import TextField from '../../form/TextField';
import LinkButton from '../../form/Button';
import CheckableStar from '../CheckableStar';
import UserCircle from '../../form/UserCircle';
import Grid from '../../layout/Grid';
import { isNullOrUndefined } from '../../../utils/objects';
import { isRelatedObjectDefined } from '../../../utils/bookable';
import { joinDefined } from '../../../utils/strings';
import GatedComponent from '../../GatedComponent';
import { getUser } from '../../../utils/sessions';
import FileUpload, { getFileName } from '../../form/UploadField';
import SaveIcon from '../../icon/SaveIcon';
import Select from '../../form/Select';
import Label from '../../form/Label';
import FlexGrid from '../../layout/FlexGrid';
import FileUploadCard from '../../cards/FileUploadCard';
import { getTaskStatus, getTaskStatusClass, updateTaskFunc } from '../TaskConstants';
import TickCircleIcon from '../../icon/TickCircleIcon';
import TaskChecklist from '../TaskChecklist';
import { withSnackbarMessage } from '../../../context/SnackbarMessage';

class ViewTaskModalDetail extends Component {
    state = {
        hideNotes: true,
        hideInfo: true,
        mutate: {
            ID: null
        }
    };

    static getDerivedStateFromProps({ task }, { mutate }) {
        if (task.node.ID !== mutate.ID) {
            const { node } = cloneDeep(task);
            return { mutate: node };
        }
        return null;
    }

    render() {
        const { classes, task, dragHandle } = this.props;
        if (!(task && !!task.node)) return null;
        const { mutate } = this.state;

        const convertDateToCheck = date => !isNullOrUndefined(date);
        const me = getUser();
        const muTask = mutate && mutate.AssignedMembers.find(e => !!e && Number(e.ID) === Number(me.ID));
        const muStar = muTask && muTask._join && muTask._join.TaskMembers && muTask._join.TaskMembers.Starred;
        const myTask = task && task.node.AssignedMembers.find(e => !!e && Number(e.ID) === Number(me.ID));
        const myStar = myTask && myTask._join && myTask._join.TaskMembers && myTask._join.TaskMembers.Starred;

        const array1 = [].concat(task.node.Attachments.map(t => Number(t.ID)));
        const array2 = [].concat(mutate.Attachments.map(m => Number(m.ID)));
        const dirtyFiles = !(
            array1.length === array2.length &&
            array1.sort().every(function(value, index) {
                return value === array2.sort()[index];
            })
        );
        const isDirty =
            !!mutate &&
            !!task &&
            !(
                !mutate.NewComment &&
                !!mutate.Completed === !!task.node.Completed &&
                !!mutate.InProgress === !!task.node.InProgress &&
                !!mutate.Archived === !!task.node.Archived &&
                !!muStar === !!myStar &&
                !dirtyFiles
            );

        return (
            <Fragment>
                <DialogTitle id={dragHandle} className={classes.diagHeader}>
                    <div className={classes.dragMe}>
                        <Icon>drag_indicator</Icon>
                    </div>
                    <div>
                        <div className={classes.diagHeaderTitle}>Task Queue</div>
                        <div className={classes.diagHeaderSubtitle}>Task Actions</div>
                    </div>
                    <GatedComponent showComponentCode="FM_ACCESS_Tasks_View">
                        {() => {
                            return (
                                <CheckableStar
                                    className={classes.starButton}
                                    value={mutate && convertDateToCheck(muStar)}
                                    onChange={checked => {
                                        const AssignedMembers = mutate.AssignedMembers.map(e => {
                                            e._join = {
                                                TaskMembers: {
                                                    Starred:
                                                        Number(e.ID) === Number(me.ID)
                                                            ? checked
                                                                ? new Date()
                                                                : null
                                                            : e._join && e._join.TaskMembers && e._join.TaskMembers.Starred
                                                }
                                            };
                                            return e;
                                        });
                                        const taskUpdate = { ...task.node, AssignedMembers };
                                        this.updateTask(taskUpdate);
                                    }}
                                />
                            );
                        }}
                    </GatedComponent>
                </DialogTitle>
                <DialogContent className={classes.content}>
                    {this.renderInfo(task)}
                    {task.node.ChecklistItems && task.node.ChecklistItems.length > 0 && (
                        <Grid container spacing={2} style={{ padding: 8, paddingTop: 0 }}>
                            <Grid item pc>
                                <InlineField>
                                    <Label>Checklist:</Label>
                                    <TaskChecklist task={task.node} canCreate={false} />
                                </InlineField>
                            </Grid>
                        </Grid>
                    )}
                    {this.renderActions(mutate)}
                </DialogContent>

                {!!mutate && !!task && (
                    <DialogActions className={classes.diagFooter}>
                        <Button className={classes.cancelButton} size="small" onClick={this.onCancel}>
                            {!!isDirty ? 'Cancel' : 'Close'}
                        </Button>
                        <GatedComponent showComponentCode="FM_ACCESS_Tasks_Edit">
                            {() => {
                                return (
                                    <Button
                                        size="small"
                                        onClick={() => this.onEdit()}
                                        color="primary"
                                        className="targetNewPage"
                                    >
                                        <Hidden smDown>Show in </Hidden>Task Queue
                                    </Button>
                                );
                            }}
                        </GatedComponent>
                        {!!isDirty ? (
                            <Button size="small" onClick={this.handleSubmit} className={classes.buttonSaved}>
                                <SaveIcon />
                                <Hidden smDown>&nbsp;Save Changes</Hidden>
                            </Button>
                        ) : (
                            <Button disabled size="small" className={classes.buttonSaved}>
                                <TickCircleIcon />
                                <Hidden smDown>&nbsp;Saved</Hidden>
                            </Button>
                        )}
                    </DialogActions>
                )}
            </Fragment>
        );
    }

    renderInfo(task) {
        const { classes } = this.props;
        const { hideInfo } = this.state;
        const overdue = task && moment() > moment(task.node.Due) && !task.node.Completed;
        const status = getTaskStatus(task.node);
        const statusClass = getTaskStatusClass(task.node);
        return (
            <Fragment>
                <Grid container spacing={2} style={{ padding: 8 }}>
                    <Grid item xs={12}>
                        <Typography variant="h4" color="primary" className={classes.title}>
                            {task.node.Title}
                        </Typography>
                        <span className={classes.toggleActivity}>
                            <LinkButton
                                variant="link"
                                text={hideInfo ? 'Show Task Details' : 'Hide Task Details'}
                                onClick={() => this.setState({ hideInfo: !hideInfo })}
                            />
                        </span>
                    </Grid>
                    {!hideInfo && (
                        <Fragment>
                            <Grid item xs={12}>
                                <div className={classes.regular}>{task.node.Description}</div>
                            </Grid>
                            <Grid item xs={12}>
                                <InlineField>
                                    <Label>Task ID: </Label>
                                    <div className={classes.regular}>#{task.node.ID}</div>
                                </InlineField>
                                {task.node.Due && (
                                    <InlineField>
                                        <Label>Due: </Label>
                                        <div className={overdue ? classes.redtext : classes.text}>
                                            <div className={classes.regular}>
                                                {moment(task.node.Due).format('dddd ll [at] LT')}
                                            </div>
                                        </div>
                                    </InlineField>
                                )}
                                <InlineField>
                                    <Label>Assigned Staff: </Label>
                                    <div className={classes.regular}>
                                        {joinDefined(
                                            task.node.AssignedMembers.sort((a, b) =>
                                                a.Surname < b.Surname ? -1 : 1
                                            ).map(
                                                user => joinDefined([user.FirstName, user.Surname], ' ') || user.Email
                                            ),
                                            ', '
                                        )}
                                    </div>
                                </InlineField>
                                {isRelatedObjectDefined(task.node.Funeral) && (
                                    <InlineField>
                                        <Label>Refers to: </Label>
                                        <div className={classes.regular}>
                                            <LinkButton
                                                variant="link"
                                                href={`/funeral/${task.node.Funeral.LegacyKey}/${task.node.Funeral.ID}`}
                                                text={'Funeral ' + task.node.Funeral.LegacyKey}
                                            />
                                            {' | '}
                                            {task.node.Funeral.NameOfDeceased}
                                        </div>
                                    </InlineField>
                                )}

                                {task.node.RequiredAction && (
                                    <InlineField>
                                        <Label>Message: </Label>
                                        <div className={classes.regular}>{task.node.RequiredAction}</div>
                                    </InlineField>
                                )}
                                <InlineField>
                                    <Label>Progress: </Label>
                                    <div className="wq-page" style={{ padding: 0 }}>
                                        <strong className={`task-status ${statusClass}`}> {status}</strong>
                                    </div>
                                </InlineField>
                            </Grid>
                        </Fragment>
                    )}
                </Grid>
            </Fragment>
        );
    }

    renderActions(mutate) {
        const { classes, task } = this.props;
        const { hideNotes } = this.state;
        const attachments = mutate.Attachments;
        let audits = [];
        if (task && task.node.Audits.edges.length > 0) {
            audits = task.node.Audits.edges.filter(e => e.node.Type === 0);
        }
        return (
            <Fragment>
                <Grid bucket>
                    <Grid item xs={12}>
                        <InlineField>
                            <Label>Set Progress:</Label>
                            <Select
                                required
                                value={
                                    !!mutate.Archived
                                        ? 'Archived'
                                        : !!mutate.Completed
                                        ? 'Completed'
                                        : !!mutate.InProgress
                                        ? 'InProgress'
                                        : ''
                                }
                                placeholder="To Do"
                                options={[
                                    { label: 'In Progress', value: 'InProgress' },
                                    { label: 'Completed', value: 'Completed' },
                                    { label: 'Archived', value: 'Archived' }
                                ]}
                                onChange={this.onTaskProgressChange}
                            />
                        </InlineField>
                    </Grid>
                    <Grid item xs={12}>
                        <Label>Upload an Attachment:</Label>
                        <FileUpload
                            buttonOnly
                            folderPath={`/documents/task/${task.node.ID}`}
                            onComplete={({ uploadFile }) => this.handleUploadAttachment(uploadFile)}
                        />
                    </Grid>
                    {!!attachments && attachments.length > 0 && (
                        <Grid item xs={12}>
                            <Label>Attached Files:</Label>
                            <FlexGrid>
                                {attachments.map(attachment => (
                                    <FileUploadCard
                                        variant="mini"
                                        key={'attachment' + attachment.ID}
                                        fileName={attachment.Name}
                                        fileLink={attachment.AbsoluteLink}
                                    />
                                ))}
                            </FlexGrid>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <Label>Leave a Note:</Label>
                        <TextField
                            multiline
                            InputLabelProps={{ shrink: true }}
                            placeholder="Enter your notes here..."
                            onChange={e =>
                                this.setState({
                                    mutate: { ...mutate, NewComment: e.target.value }
                                })
                            }
                            value={mutate ? mutate.NewComment : null}
                        />
                        {audits.length > 0 && (
                            <span className={classes.toggleActivity}>
                                <LinkButton
                                    variant="link"
                                    text={hideNotes ? 'Show Previous Notes' : 'Hide Previous Notes'}
                                    onClick={() => this.setState({ hideNotes: !hideNotes })}
                                />
                            </span>
                        )}
                    </Grid>

                    {!hideNotes && (
                        <Grid item xs={12} className={classes.audit}>
                            {audits.filter(e => e.node.Type === 0).map(audit => this.renderAudit(audit))}
                        </Grid>
                    )}
                </Grid>
            </Fragment>
        );
    }

    renderAudit = audit => {
        const { classes } = this.props;
        return (
            <InlineField className={classes.auditItem} key={audit.node.ID}>
                <span>
                    <UserCircle useTag={false} member={audit.node.AddedBy} />
                </span>
                <span>
                    <span className={classes.auditDetails}>
                        {`Added notes on ${moment(audit.node.Created).format('ll [at] LT')}`}
                    </span>
                    <br />
                    <span className={classes.auditType}>{audit.node.Comment}</span>
                </span>
            </InlineField>
        );
    };

    updateTask(task) {
        const { setSnackbarMessage } = this.props;

        return updateTaskFunc(task).then(
            result => {
                const { updateTask } = cloneDeep(result.data);
                if (updateTask) {
                    setSnackbarMessage('Success, your changes have been saved.', true);
                    this.setState({ mutate: updateTask });
                } else {
                    setSnackbarMessage('Oops! Failed to reload the task.');
                }
            },
            () => setSnackbarMessage('Oops! Failed to update the task.')
        );
    }

    handleUploadAttachment(uploadFile) {
        const { mutate } = this.state;
        const { Attachments } = mutate;
        Attachments.push({
            ID: uploadFile.ID,
            AbsoluteLink: uploadFile.AbsoluteLink,
            Name: getFileName(uploadFile.FileName)
        });
        this.setState({
            mutate
        });
    }

    handleSubmit = () => {
        const { mutate } = this.state;
        this.updateTask(mutate);
    };

    onTaskProgressChange = e => {
        const value = e.target.value;
        const { mutate } = this.state;
        mutate.Archived = value === 'Archived' ? new Date() : null;
        mutate.Completed = value === 'Completed' ? new Date() : null;
        mutate.InProgress = value === 'InProgress';
        this.setState({ mutate });
    };

    onEdit() {
        const { onEdit, task } = this.props;
        if (onEdit) onEdit(task);
        else {
            const win = window.open('/work-queue/task/' + task.node.ID);
            win.focus();
        }
    }

    onCancel = () => {
        const { onClose } = this.props;
        if (onClose) onClose();
        this.clearState();
    };

    clearState() {
        const clearedState = Object.keys(this.state).reduce((acc, key) => {
            acc[key] = '';
            return acc;
        }, {});
        this.setState(clearedState);
    }
}

const styles = ({ palette, breakpoints, spacing }) => ({
    text: {},
    redtext: { color: 'red' },
    buttonSave: {
        padding: '0.65em 1.5em'
    },
    buttonSaved: { color: palette.action.save },
    buttonClose: {},
    dragMe: {
        color: 'white',
        width: 32,
        marginLeft: -32,
        opacity: 0.5,
        flex: '0 0 auto!important'
    },
    diagHeader: {
        background: palette.primary.main,
        // borderRadius: '10px 10px 0 0',
        padding: '30px 44px',
        cursor: 'move',
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            '& div': {
                flex: '1 1 auto'
            }
        },
        position: 'sticky',
        zIndex: 1,
        top: 0
    },
    diagFooter: {
        position: 'sticky',
        zIndex: 1,
        bottom: 0,
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0px 20px 6px'
    },
    diagHeaderTitle: {
        color: '#FFFFFF',
        fontSize: '16px',
        fontWeight: 'lighter',
        lineHeight: 'normal'
    },
    diagHeaderSubtitle: {
        color: '#FFFFFF',
        fontSize: '36px',
        fontWeight: 'initial',
        lineHeight: 'normal',
        [breakpoints.down('sm')]: {
            fontSize: '24px'
        }
    },
    content: {
        maxHeight: 'calc(100vh - 260px)',
        overflow: 'auto',
        width: '100%',
        padding: '16px 36px 0',
        '& label': {
            minWidth: 112,
            marginRight: 16
        },
        [breakpoints.down('sm')]: {
            padding: spacing(1)
        }
    },
    starButton: {
        width: 'unset',
        height: 'unset',
        '& svg': {
            width: '2.5em',
            height: '2.5em'
        }
    },
    title: {
        fontSize: '36px',
        [breakpoints.down('sm')]: {
            fontSize: '24px'
        }
    },
    regular: {
        fontSize: '16px',
        fontWeight: 'lighter',
        whiteSpace: 'pre-wrap'
    },
    toggleActivity: {
        fontSize: '12px',
        float: 'right',
        marginTop: spacing(1)
    },
    userCircleCell: {
        width: '50px'
    },
    userCircle: {
        height: '35px',
        width: '35px',
        background: '#7BDBFF',
        borderRadius: '20px',
        fontSize: '15px',
        textAlign: 'center',
        color: '#FFFFFF',
        display: 'inline-block',
        '& > *': {
            lineHeight: '34px'
        }
    },
    auditType: {
        fontSize: '14px',
        whiteSpace: 'pre-wrap'
    },
    auditDetails: {
        fontSize: '13px',
        fontWeight: 'lighter'
    },
    auditItem: {
        // alignItems: 'baseline',
        margin: '8px 0',
        padding: 8,
        borderRadius: 6,
        '&:hover': { background: 'rgba(0, 0, 0, 0.05)' },
        '&:first-of-type': { marginTop: 0 },
        '& > span': { lineHeight: '16px!important' }
    },
    audit: {
        maxHeight: '250px',
        overflowX: 'hidden',
        overflowY: 'auto'
        // padding: '0 8px !important',
        // borderBottom: '1px solid ' + palette.contentForeground.none + '33',
        // marginBottom: 16
    },
    cancelButton: {
        color: palette.action.destroy,
        textDecoration: 'underline'
    }
});

export default compose(withStyles(styles), withSnackbarMessage)(ViewTaskModalDetail);
